import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Spinner } from 'react-bootstrap';
import { sendAlert } from '../../actions/utils';
import { ComponentDataTable, DefaultModal } from '../../components';
import { deleteDncRequest } from '../../requests/dncs';
import { delayMethod } from '../../services/utils';

const DncDatatable = ({
  dncs,
  amount,
  onRequest,
  handleIndexRequest,
  customParams,
  moreData,
  setMoreData,
  columnDnc,
  boss,
  clickHandler
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState({});
  const [modalItem, setModalItem] = useState(null);
  const [request, setRequest] = useState(onRequest);
  const [disabled, setIsDisable] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();

  const handleDeleteRequest = id => {
    setIsDisable(true);
    setRequest(onRequest);
    deleteDncRequest(id, {
      dispatch,
      successCallback: () => {
        setRequest(!onRequest);
        setIsDisable(false);
        dispatch(sendAlert({ kind: 'success', message: 'DNC eliminado con éxito' }));
        setMoreData(!moreData);
      },
      callback: () =>
        delayMethod(() => {
          setModalShow(false);
          setIsDisable(false);
        })
    });
  };

  const handleActions = (item, action) => {
    if (clickHandler) {
      clickHandler(item, action);
      return;
    }
    switch (action) {
      case 'show':
        if (boss) {
          history.push(`/profile/dnc/${item.id}`);
        } else {
          history.push(`/dnc/${item.id}`);
        }
        break;
      case 'edit':
        if (boss) {
          history.push(`/profile/dnc/${item.id}/edit`);
        } else {
          history.push(`/dnc/${item.id}/edit`);
        }
        break;
      case 'destroy':
        setModalItem(item);
        setModalShow(true);
        setModalBody(<div className="ml-2">¿Estás seguro que deseas eliminar {item.name}?</div>);
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn('Error: Action not found');
        break;
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'job_management_name':
        return { sort_job_managements: name };
      case 'leadership':
        return { sort_leadership: name };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <div className="position-relative">
        {onRequest && (
          <div
            className="containerSpinnerLoad position-absolute h-100 w-100 d-flex align-items-center justify-content-center"
            style={{ zIndex: 10, top: 0, left: 0 }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <ComponentDataTable
          onRequest={onRequest}
          columns={columnDnc(handleActions)}
          handleSortCase={sortColumnCase}
          data={dncs}
          totalRows={amount}
          resourceRequest={handleIndexRequest}
          onRowClicked={row => handleActions(row, 'edit')}
          customParams={customParams}
          moreData={moreData}
          pointerOnHover
          customSpinnerClass="d-none"
        />
      </div>
      <DefaultModal
        title="Eliminar DNC"
        body={modalBody}
        show={modalShow}
        handleClose={() => delayMethod(() => setModalShow(false))}
        handleConfirm={() => handleDeleteRequest(modalItem.id)}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        disabled={!request || disabled}
      />
    </>
  );
};

export default DncDatatable;
